module.exports = __webpack_public_path__ + "static/img/5.10476ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/5.png
// module id = k/7L
// module chunks = 0